let Artists = [
  {
    name: "ROBERT",
    url: "ROBERT",
    profileimg: "./imgs/artists/1.webp",
    position: "Owner, Tattoo Artist",
    portfolioLinks: [
      { title: "Project 1", url: "./imgs/portfolio/artist1/1.webp" },
      { title: "Project 2", url: "./imgs/portfolio/artist1/2.webp" },
      { title: "Project 3", url: "./imgs/portfolio/artist1/3.webp" },
      { title: "Project 4", url: "./imgs/portfolio/artist1/4.webp" },
      { title: "Project 5", url: "./imgs/portfolio/artist1/5.webp" },
    ],
  },
  {
    name: "JINX",
    url: "JINX",
    profileimg: "./imgs/artists/2.webp",
    position: "Tattoo Artist",
    portfolioLinks: [
      { title: "Project 1", url: "./imgs/portfolio/artist2/1.webp" },
      { title: "Project 2", url: "./imgs/portfolio/artist2/2.webp" },
      { title: "Project 3", url: "./imgs/portfolio/artist2/3.webp" },
      { title: "Project 4", url: "./imgs/portfolio/artist2/4.webp" },
      { title: "Project 5", url: "./imgs/portfolio/artist2/5.webp" },
    ],
  },
  {
    name: "ALEX",
    url: "ALEX",
    profileimg: "./imgs/artists/3.webp",
    position: "Tattoo Artist",
    portfolioLinks: [
      { title: "Project 1", url: "./imgs/portfolio/artist3/1.webp" },
      { title: "Project 2", url: "./imgs/portfolio/artist3/2.webp" },
      { title: "Project 3", url: "./imgs/portfolio/artist3/3.webp" },
      { title: "Project 4", url: "./imgs/portfolio/artist3/4.webp" },
      { title: "Project 5", url: "./imgs/portfolio/artist3/5.webp" },
    ],
  },
  {
    name: "RAVEN",
    url: "RAVEN",
    profileimg: "./imgs/artists/4.webp",
    position: "Tattoo Artist",
    portfolioLinks: [
      { title: "Project 1", url: "./imgs/portfolio/artist4/1.webp" },
      { title: "Project 2", url: "./imgs/portfolio/artist4/2.webp" },
      { title: "Project 3", url: "./imgs/portfolio/artist4/3.webp" },
      { title: "Project 4", url: "./imgs/portfolio/artist4/4.webp" },
      { title: "Project 5", url: "./imgs/portfolio/artist4/5.webp" },
    ],
  },
  {
    name: "COHEN",
    url: "COHEN",
    profileimg: "./imgs/artists/5.webp",
    position: "Tattoo Artist",
    portfolioLinks: [
      { title: "Project 1", url: "./imgs/portfolio/artist5/1.webp" },
      { title: "Project 2", url: "./imgs/portfolio/artist5/2.webp" },
      { title: "Project 3", url: "./imgs/portfolio/artist5/3.webp" },
      { title: "Project 4", url: "./imgs/portfolio/artist5/4.webp" },
      { title: "Project 5", url: "./imgs/portfolio/artist5/5.webp" },
    ],
  },
  {
    name: "MAGGIE",
    url: "MAGGIE",
    profileimg: "./imgs/artists/6.webp",
    position: "Tattoo Artist",
    portfolioLinks: [
      { title: "Project 1", url: "./imgs/portfolio/artist6/1.webp" },
      { title: "Project 2", url: "./imgs/portfolio/artist6/2.webp" },
      { title: "Project 3", url: "./imgs/portfolio/artist6/3.webp" },
      { title: "Project 4", url: "./imgs/portfolio/artist6/4.webp" },
      { title: "Project 5", url: "./imgs/portfolio/artist6/5.webp" },
    ],
  },
  {
    name: "DANIEL",
    url: "DANIEL",
    profileimg: "./imgs/artists/7.webp",
    position: "Piercing Artist",
    portfolioLinks: [
      { title: "Project 1", url: "./imgs/portfolio/artist7/1.webp" },
      { title: "Project 2", url: "./imgs/portfolio/artist7/2.webp" },
      { title: "Project 3", url: "./imgs/portfolio/artist7/3.webp" },
      { title: "Project 4", url: "./imgs/portfolio/artist7/4.webp" },
      { title: "Project 5", url: "./imgs/portfolio/artist7/5.webp" },
    ],
  },
  {
    name: "TOBIE",
    url: "TOBIE",
    profileimg: "./imgs/artists/8.webp",
    position: "Tattoo Artist",
    portfolioLinks: [
      { title: "Project 1", url: "./imgs/portfolio/artist8/1.webp" },
      { title: "Project 2", url: "./imgs/portfolio/artist8/2.webp" },
      { title: "Project 3", url: "./imgs/portfolio/artist8/3.webp" },
      { title: "Project 4", url: "./imgs/portfolio/artist8/4.webp" },
      { title: "Project 5", url: "./imgs/portfolio/artist8/5.webp" },
    ],
  },
  {
    name: "MARIE",
    url: "MARIE",
    profileimg: "./imgs/artists/9.webp",
    position: "Tattoo Artist",
    portfolioLinks: [],
  },
];

export default Artists;
